import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const ProductionDashboardRoute: RouteType = {
  name: "Production Dashboard",
  path: "/production/dashboard",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Production Dashboard",
      component: () => import("./ProductionDashboardHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProductionDashboardBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Initialize the dashboard view store

      // Load critical production stores
      const promises = [];

      // Load panels for production metrics
      const panelStore = rootStore.panelStore as ServiceStore;
      if (panelStore) {
        promises.push(panelStore.find());
      }

      // Load production orders
      const productionOrdersStore =
        rootStore.productionOrdersStore as ServiceStore;
      if (productionOrdersStore) {
        promises.push(productionOrdersStore.find());
      }

      // Load holds
      const holdStore = rootStore.holdStore as ServiceStore;
      if (holdStore) {
        promises.push(holdStore.find());
      }

      // Load job schedules
      const jobScheduleStore = rootStore.jobScheduleStore as ServiceStore;
      if (jobScheduleStore) {
        promises.push(jobScheduleStore.find());
      }

      // Load jobs for filtering
      const jobStore = rootStore.jobStore as ServiceStore;
      if (jobStore) {
        promises.push(jobStore.find());
      }

      // Load products
      const productsStore = rootStore.productsStore as ServiceStore;
      if (productsStore) {
        promises.push(productsStore.find());
      }

      // Load bill of materials
      const billOfMaterialsStore =
        rootStore.billOfMaterialsStore as ServiceStore;
      if (billOfMaterialsStore) {
        promises.push(billOfMaterialsStore.find());
      }

      // Execute all data loading in parallel
      await Promise.all(promises);

      // Load dashboard data after stores are populated
      const viewStore = (rootStore as any).productionDashboardViewStore;
      if (viewStore) {
        await viewStore.loadDashboardData();
      }

      return true;
    } catch (error) {
      console.error("Failed to load production dashboard data:", error);
      return true; // Allow navigation even if data loading fails
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).productionDashboardViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default ProductionDashboardRoute;
